import { render, staticRenderFns } from "./activate-deactivate.vue?vue&type=template&id=0b798268&scoped=true"
import script from "./activate-deactivate.vue?vue&type=script&lang=js"
export * from "./activate-deactivate.vue?vue&type=script&lang=js"
import style0 from "./activate-deactivate.vue?vue&type=style&index=0&id=0b798268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b798268",
  null
  
)

export default component.exports